export class Paginate {
  perpage = 100;
  activepage = 1;
  maxpage = 1;
  lengthdata = 0;

  constructor() {}

  getmaxpage() {
    return this.maxpage;
  }

  getperpage() {
    return this.perpage;
  }

  setlengthdata(lengthdata) {
    this.lengthdata = Number(lengthdata);

    if (isNaN(this.lengthdata) || this.lengthdata < 1) {
      this.lengthdata = 1;
    }

    this.maxpage = Math.ceil(this.lengthdata / this.perpage);
  }

  setperpage(n) {
    this.perpage = Number(n);

    if (isNaN(this.perpage) || this.perpage < 1) {
      this.perpage = 1;
    }

    this.maxpage = Math.ceil(this.lengthdata / this.perpage);
  }

  setactivepage(n) {
    this.activepage = Number(n);
  }

  visiblepage() {
    if (this.maxpage <= 5) {
      return Array.from({ length: this.maxpage }, (_, i) => i + 1);
    }

    if (this.activepage <= 3) {
      return [1, 2, 3, "...", this.maxpage];
    }

    if (this.activepage >= this.maxpage - 2) {
      return [1, "...", this.maxpage - 2, this.maxpage - 1, this.maxpage];
    }

    return [
      1,
      "...",
      this.activepage - 1,
      this.activepage,
      this.activepage + 1,
      "...",
      this.maxpage,
    ];
  }
}
